import { render, staticRenderFns } from "./PublicationForm.vue?vue&type=template&id=3bacc6c2&"
import script from "./PublicationForm.vue?vue&type=script&lang=ts&"
export * from "./PublicationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports